import GenerateAPI from '../generate.js'

const config = {
    list: {
        url: '/client/necessary/list',
        apiType: 'check',
    },
    save: {
        url: '/pay/title/save',
    },
    submit: {
        url: '/client/necessary/submitOrder',
    },
    submitData: {
        url: '/client/necessary/submit/data',
        apiType: 'check',
    },
    data: {
        url: '/client/necessary/toPay/data',
        apiType: 'check',
    },
    check: {
        url: '/client/necessary/pay/check',
        apiType: 'check',
    },
    operate: {
        url: '/client/necessary/operate',
        apiType: 'check',
    },
    pay: {
        url: '/client/necessary/pay',
    },
    checkUnpay: {
        url: '/client/necessary/checkUnpay',
        apiType: 'check',
    }
}

const apiUnpaidFee = GenerateAPI.generate(config)
let baseUrl = process.env.VUE_APP_BASE_API
baseUrl = baseUrl.startsWith('http') ? baseUrl : window.location.protocol + '//' + baseUrl
apiUnpaidFee.payPage= baseUrl+'/client/necessary/payPage'
export default apiUnpaidFee
